import React from 'react';
import './styles/errorModalContent.scss';
import {useTranslation} from 'react-i18next';

interface IErrorModalContentProps {
    title?: string;
    description?: string;
    className?: string;
    titleClassName?: string;
    descriptionClassName?: string;
}

function ErrorModalContent({title, description, titleClassName, descriptionClassName, className}: IErrorModalContentProps): JSX.Element {
    const {t} = useTranslation();
    return (
        <div className={`${className || 'c-errorModalContent'}`}>
            <div className={`${titleClassName || 'c-errorModalContent__title'}`}>{title || t('common.error')}</div>
            <div className={`${descriptionClassName || 'c-errorModalContent__description'}`}>
                {description || t('common.errorDescription')}
            </div>
        </div>
    );
}

export default ErrorModalContent;
